/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
export default class SoundMeter {
  constructor() {
    this.consumeBuffer = ({
      inputBuffer
    }) => {
      const buf = inputBuffer.getChannelData(0);
      const bufLength = buf.length;
      let sum = 0;
      let x;
      for (let i = 0; i < bufLength; i++) {
        x = buf[i];
        sum += x * x;
      }
      const rms = Math.sqrt(sum / bufLength);
      this.volume = Math.max(rms, this.volume * this.averaging);

      // if no audio input is detected in this period of time (100ms)
      // it means indicator should be 0 and not the volume calculated from last known buffer
      // unless input stream always has audio track to update buffer with 0 values (no line 41 executed)
      this.staleVolumeAfter(100);
    };
    this.context = new AudioContext();
    this.processor = this.context.createScriptProcessor(512);
    this.volume = 0;
    this.averaging = 0.95;
    this.processor.onaudioprocess = this.consumeBuffer;
  }
  connectToSource(stream) {
    try {
      this.mic = this.context.createMediaStreamSource(stream);
      this.mic.connect(this.processor);
      // although processor can be connected in constructor
      // we don't want onaudioprocess to trigger unless we have connected mic
      this.processor.connect(this.context.destination);
    } catch (error) {
      if (error.message.endsWith('has no audio track')) {
        this.volume = 0;
      } else {
        throw error;
      }
    }
  }
  async stop() {
    if (this.context.state !== 'closed') {
      this.disconnectPrevStream();
      await this.context.close();
    }
  }
  disconnectPrevStream() {
    this.mic && this.mic.disconnect();
    // do not run onaudioprocess without connected mic
    this.processor && this.processor.disconnect();
  }
  staleVolumeAfter(time) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.volume = 0, time);
  }
}